import React, { useState, Fragment } from 'react';
// External components
import { Row, Col } from 'react-simple-flex-grid';
// Components
import SearchFilterPanel from './ProductsMap/SearchFilterPanel.jsx';
import FilterDetails from '../common/FilterDetails/FilterDetails.jsx';
import Sidebar from './ProductsMap/Sidebar.jsx';
import GoogleApiWrapper from './ProductsMap/MapContainer.jsx';
import Loading from "../common/Loading/Loading.jsx";
// Helper
import { isNull } from '../lib/helpers.js';
// Styles
import './ProductsMap/productsmapFrame.css';



// For future unit testing
export const filterProductsByLatLong = (frameData) => {
    return frameData.filter((prod) => {
        return !isNull(prod.latitude) && !isNull(prod.longitude);
    });
}

function ProductsMapFrame({
    namedstrings,
    frameInfo
}) {
    const {
        frameData,
        mapOnly,
        typographyItems,
        digitalProductTypes,
        availableOnlineText,
        enableRoundedCorners
    } = frameInfo;
    const [isLoading, setIsLoading] = useState(false);
    const [products, setProducts] = useState(filterProductsByLatLong(frameData));
    const [locations, setLocations] = useState([]);
    const [currentLocation, setCurrentLocation] = useState();
    const [currentProducts, setCurrentProducts] = useState(frameData);
 
    // ACTION CALLBACKS:

    function locationButtonTapped(evt) {
        navigator?.geolocation?.getCurrentPosition(pos => {
            const coords = pos.coords;
            setCurrentLocation({
                lat: coords.latitude,
                lng: coords.longitude
            });
        });
    }

    function filtersChanged(location) {
        setIsLoading(true);
        const filteredProducts = products.filter((p) => {
            return p.geographicId = location;
        });

        setCurrentProducts(filteredProducts);
        setIsLoading(false);
    }

    return (
        <Fragment>
            {!mapOnly && (
                <Row className="map-frame-content">
                    <Col xs={11} sm={4} className="map-frame-product-content">
                        <SearchFilterPanel
                            typographyItems={typographyItems}
                            locations={locations}
                            gpsButtonTapped={locationButtonTapped}
                            filtersChanged={filtersChanged}
                        />
                        <FilterDetails 
                            count={products.length} 
                            results={namedstrings['results']}
                        />

                        {isLoading ? (
                            <Loading />
                        ) :
                            <Sidebar
                                products={products}
                                digitalProducts={digitalProductTypes}
                                digitalText={availableOnlineText}
                                sideBarWarning={namedstrings['sideBarWarning']}
                                enableRoundedCorners={enableRoundedCorners}
                            />
                        }
                    </Col>
                    <Col xs={11} sm={8} className="map-frame-map-content">
                        <div className="sticky-top">
                            <GoogleApiWrapper
                                data={products}
                                currentLocation={currentLocation}
                                digitalProducts={digitalProductTypes}
                                digitalText={availableOnlineText}
                            />
                        </div>
                    </Col>
                </Row>
            )}
            {mapOnly && (
                <Row className="map-frame-content">
                    <Col xs={11} className="map-frame-map-content">
                        <div className="sticky-top">
                            <GoogleApiWrapper
                                data={products}
                                currentLocation={currentLocation}
                                digitalProducts={digitalProductTypes}
                                digitalText={availableOnlineText}
                            />
                        </div>
                    </Col>
                </Row>
            )}
        </Fragment>  
    )
}

export default ProductsMapFrame;
